/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessNumberListItem } from '../../models/access-number-list-item';

export interface GetAccessnumberMinified$Plain$Params {
  'api-version'?: string;
}

export function getAccessnumberMinified$Plain(http: HttpClient, rootUrl: string, params?: GetAccessnumberMinified$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccessNumberListItem>>> {
  const rb = new RequestBuilder(rootUrl, getAccessnumberMinified$Plain.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AccessNumberListItem>>;
    })
  );
}

getAccessnumberMinified$Plain.PATH = '/accessnumber/minified';
